// Mock data for Enliven Elite Tax Pro

export const mockServices = [
  {
    id: 1,
    title: "Individual Tax Preparation",
    description: "Professional Form 1040 preparation with accuracy and care",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Self-Employed & 1099 Filing",
    description: "Specialized tax services for independent contractors",
    icon: "Briefcase"
  },
  {
    id: 3,
    title: "Small Business & LLC Returns",
    description: "Comprehensive tax solutions for your business",
    icon: "Building2"
  },
  {
    id: 4,
    title: "Schedule C Filings",
    description: "Expert handling of business income and expenses",
    icon: "Calculator"
  },
  {
    id: 5,
    title: "Prior-Year & Amended Returns",
    description: "Corrections and catch-up filings handled professionally",
    icon: "RefreshCw"
  },
  {
    id: 6,
    title: "Estimated Tax Payments",
    description: "Strategic planning for quarterly tax obligations",
    icon: "Calendar"
  },
  {
    id: 7,
    title: "IRS Compliance Support",
    description: "Expert guidance for audits and IRS communications",
    icon: "Shield"
  }
];

export const mockWhyChoose = [
  {
    id: 1,
    title: "Accuracy-Focused Tax Preparation",
    description: "Meticulous attention to detail ensures maximum accuracy"
  },
  {
    id: 2,
    title: "Secure & Confidential Client Process",
    description: "Your financial information is protected with industry-leading security"
  },
  {
    id: 3,
    title: "Professional, Personalized Service",
    description: "Dedicated support tailored to your unique tax situation"
  },
  {
    id: 4,
    title: "Experience with Individual & Business Filings",
    description: "Comprehensive expertise across all filing types"
  },
  {
    id: 5,
    title: "Nationwide Service Availability",
    description: "Professional tax services wherever you are located"
  }
];

export const mockAppointmentSlots = [
  { id: 1, date: "2025-08-18", time: "09:00 AM", available: true },
  { id: 2, date: "2025-08-18", time: "11:00 AM", available: true },
  { id: 3, date: "2025-08-18", time: "02:00 PM", available: false },
  { id: 4, date: "2025-08-19", time: "10:00 AM", available: true },
  { id: 5, date: "2025-08-19", time: "01:00 PM", available: true },
  { id: 6, date: "2025-08-20", time: "09:00 AM", available: true }
];

// Mock form submission handlers
export const mockSubmitSubscription = (email) => {
  console.log("[MOCK] Email subscription submitted:", email);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Successfully subscribed!" });
    }, 1000);
  });
};

export const mockSubmitContactForm = (formData) => {
  console.log("[MOCK] Contact form submitted:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Message sent successfully!" });
    }, 1000);
  });
};

export const mockSubmitAppointment = (appointmentData) => {
  console.log("[MOCK] Appointment booked:", appointmentData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Appointment booked successfully!" });
    }, 1000);
  });
};